var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"reset"}},[(_vm.flag == 2)?_c('div',{staticClass:"phone"},[(_vm.dialogData.flag)?_c('my_dialog',{attrs:{"myDialogData":_vm.dialogData}}):_vm._e()],1):_vm._e(),(_vm.flag == 1)?_c('div',{staticClass:"pc"},[(_vm.dialogData.flag)?_c('my_dialogPc',{attrs:{"myDialogData":_vm.dialogData}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }